module.exports = __webpack_public_path__ + "static/media/logo_app.4f559751.jpg";